<template>
  <div class="abstract-card">
    <div class="header">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractAuthors.instruction')}} <el-switch v-model="form.enableInstructionsForAuthors"></el-switch></div>
      <span>{{$t('components.abstract.tabs.abstractAuthors.instructionMsg')}}</span>
    </div>
    <transition name="el-fade-in">
      <div v-show="form.enableInstructionsForAuthors">
        <el-row :gutter="24">
          <el-col :span="24" class="mt-2">
            <div class="registerform-input-container mt-2">
              <div class="title">
                <div>
                  <label>{{$t('components.abstract.tabs.abstractAuthors.instructionMsgSpecial')}}</label>
                  <el-tooltip content="Content" placement="bottom">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
              </div>
              <quill-editor :options="editorOption" ref="myQuillEditor" v-model="form.instructionsForAuthors" @ready="onEditorReady($event)" />
              <span class="error">{{ $errorMessage('instructionsForAuthors', validationErrors) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </transition>

    <div class="header mt-3">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractAuthors.authors')}}<el-switch v-model="form.enableAuthors"></el-switch></div>
      <span>{{$t('components.abstract.tabs.abstractAuthors.authorsMsg')}}</span>
    </div>
    <transition name="el-fade-in">
      <el-row :gutter="10" v-show="form.enableAuthors">
        <el-col :span="24">
          <div class="registerform-input-container mt-2">
            <div class="title">
              <div>
                <label>{{$t('components.abstract.tabs.abstractAuthors.title')}}</label>
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </div>
            <el-input v-model="form.enableAuthorsTitle"></el-input>
            <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
          </div>
        </el-col>
        <el-col :span="24" v-if="form.authorSettings">
          <el-row :gutter="10">
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.firstNameTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.firstNameTitle" :disabled="!form.authorSettings.firstName"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.firstName"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.lastNameTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.lastNameTitle" :disabled="!form.authorSettings.lastName"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.lastName"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.emailTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.emailTitle" :disabled="!form.authorSettings.email"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.email"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.phoneTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.phoneTitle" :disabled="!form.authorSettings.phone"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.phone"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.institutionTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.institutionTitle" :disabled="!form.authorSettings.institution"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.institution"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.countryTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.countryTitle" :disabled="!form.authorSettings.country"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.country"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.stateTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.stateTitle" :disabled="!form.authorSettings.state"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.state"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="mt-2">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{ $t('abstract.authorSettings.cityTitle') }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-row :gutter="20" class="d-flex align-items-center">
                  <el-col :span="20">
                    <el-input v-model="form.authorSettings.cityTitle" :disabled="!form.authorSettings.city"></el-input>
                    <span class="error">{{ $errorMessage('enableAuthorsTitle', validationErrors) }}</span>
                  </el-col>
                  <el-col :span="4"> <el-switch v-model="form.authorSettings.city"></el-switch></el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </transition>
    <div class="bottom mt-3 d-flex justify-content-end">
      <el-button type="primary" size="mini" round :loading="loading" @click="saveAbstractAuthors">{{$t('components.abstract.tabs.abstractAuthors.save')}}</el-button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';

  export default {
    components: {
      quillEditor,
    },
    props: ['data'],
    data() {
      return {
        axios,
        loading: false,
        timeout: null,
        form: null,
        validationErrors: [],
        editorOption: {
          modules: {
            toolbar: {
              container: [['bold', 'italic', 'underline', 'strike']],
              handlers: {
                image: () => {
                  this.selectLocalImage();
                },
              },
            },

            syntax: {
              highlight: (text) => hljs.highlightAuto(text).value,
            },

            resize: {
              modules: ['Resize'],
            },
          },
        },
      };
    },
    methods: {
      async saveAbstractAuthors() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.loading = true;
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch('abstractUpdateAuthors', this.form);
          this.validationErrors = res.data.validationErrors;
          this.loading = false;
        }, 500);
      },
      onEditorReady(editor) {
        editor.root.setAttribute('data-placeholder', this.$t('enterText'));
        editor.getModule('toolbar').addHandler('image', () => {
          this.selectLocalImage(editor);
        });
      },
      selectLocalImage() {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();
        input.onchange = () => {
          const file = input.files[0];
          if (/^image\//.test(file.type)) {
            this.saveToServer(file);
          } else {
            console.warn('You could only upload images.');
          }
        };
      },
      saveToServer(file) {
        const fd = new FormData();
        fd.append('image', file);
        const xhr = new XMLHttpRequest();
        xhr.open('POST', axios.defaults.baseURL + 'event/uploadImage?uploadType=html&language=' + this.$i18n.locale, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));

        xhr.onload = () => {
          if (xhr.status === 200) {
            const body = JSON.parse(xhr.responseText);
            if (body.alert.hasError == false) {
              const url = body.data.item.url;
              this.insertToEditor(url);
            } else {
              this.$message.error(body.alert.message);
            }
          }
        };

        xhr.send(fd);
      },
      insertToEditor(url) {
        const range = this.$refs.myQuillEditor.quill.getSelection();
        this.$refs.myQuillEditor.quill.insertEmbed(range.index, 'image', `${url}`);
      },
      setBaseText() {
        this.$nextTick(() => {
          if (this.form != null) {
            if (this.form.authorSettings.firstNameTitle == null || this.form.authorSettings.firstNameTitle == '') {
              this.form.authorSettings.firstNameTitle = this.$t('abstract.authorSettings.firstNameTitle');
            }
            if (this.form.authorSettings.lastNameTitle == null || this.form.authorSettings.lastNameTitle == '') {
              this.form.authorSettings.lastNameTitle = this.$t('abstract.authorSettings.lastNameTitle');
            }
            if (this.form.authorSettings.emailTitle == null || this.form.authorSettings.emailTitle == '') {
              this.form.authorSettings.emailTitle = this.$t('abstract.authorSettings.emailTitle');
            }
            if (this.form.authorSettings.phoneTitle == null || this.form.authorSettings.phoneTitle == '') {
              this.form.authorSettings.phoneTitle = this.$t('abstract.authorSettings.phoneTitle');
            }
            if (this.form.authorSettings.institutionTitle == null || this.form.authorSettings.institutionTitle == '') {
              this.form.authorSettings.institutionTitle = this.$t('abstract.authorSettings.institutionTitle');
            }
            if (this.form.authorSettings.countryTitle == null || this.form.authorSettings.countryTitle == '') {
              this.form.authorSettings.countryTitle = this.$t('abstract.authorSettings.countryTitle');
            }
            if (this.form.authorSettings.stateTitle == null || this.form.authorSettings.stateTitle == '') {
              this.form.authorSettings.stateTitle = this.$t('abstract.authorSettings.stateTitle');
            }
            if (this.form.authorSettings.cityTitle == null || this.form.authorSettings.cityTitle == '') {
              this.form.authorSettings.cityTitle = this.$t('abstract.authorSettings.cityTitle');
            }
          }
        });
      },
    },
    created() {
      if (this.data != undefined && this.data != null) {
        this.$nextTick(() => {
          this.form = this.data;
        });
        this.$nextTick(() => {
          this.setBaseText();
        });
      }
    },
    watch: {
      data: function() {
        if (this.data != undefined && this.data != null) {
          this.$nextTick(() => {
            this.form = this.data;
          });
          this.$nextTick(() => {
            this.setBaseText();
          });
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .authors-card {
    padding: 1rem !important;
    border: 1px solid #ccc;
  }
  .abstract-card {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.5);
    padding: 1rem;

    & > .header {
      color: black;
      & > .title {
        display: flex;
        font-weight: bold;
        justify-content: space-between;
        align-items: center;
      }
      span {
        font-weight: 400;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/AbstractAuthors.vue